
  <div class="row mt-2">
    <div class="col-12" *ngIf="fire.incident && fullScreen">
      <div class="card mb-4">
        <div class="card-body profile">
         
          <div class="profile-container">
            
            <div class="profile-sidebar">
              <div class="profile cursor" [routerLink]="'/fire-foresight/camera/' + fire.incident.site.siteId">
                <i class="fa fa-camera"></i>
              </div>
              <h4>{{fire.incident.site.name}}</h4>
              <h5>{{fire.incident.cameraBearing}}°</h5>
            </div>
            
            <div class="profile-content">
              <div class="table-responsive">
                <table class="table text-center">
                  <thead>
                    <tr>
                      <th>Confidence</th>
                      <th>Detections</th>
                      <th>Bearing</th>
                      <th class="d-none d-lg-table-cell">Field of View</th>
                      <th>First Detected</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="nav-value" [ngClass]="{'text-danger':fire.incident.confidence > 50}"><i class="fa fa-fire fa-fw me-1"></i> {{fire.incident.confidence}}%</div>
                      </td>
                      <td>
                        <div class="nav-value" [ngClass]="{'text-danger':fire.incident.detections.length > 1}">{{fire.incident.detections.length}}</div>
                      </td>
                      <td>
                        <div class="nav-value">{{fire.incident.bearing | number:'1.1-1'}}°</div>
                      </td>
                      <td class="d-none d-lg-table-cell">
                        <div class="nav-value">{{360/getSegments()}}°</div>
                      </td>
                      <td>
                        <div class="nav-value">{{fire.incident.fireIncidentDate | relativeDate}}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--<ul class="profile-tab nav nav-tabs nav-tabs-v2" role="tablist">
                <li class="nav-item" role="presentation">
                <a href="#profile-post" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">
                <div class="nav-field">Confidence</div>
                <div class="nav-value" [ngClass]="{'text-danger':fire.incident.confidence > 50}"><i class="fa fa-fire fa-fw me-1"></i> {{fire.incident.confidence}}%</div>
                </a>
                </li>
                <li class="nav-item" role="presentation">
                <a href="#profile-followers" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1">
                <div class="nav-field">Detections</div>
                <div class="nav-value" [ngClass]="{'text-danger':fire.incident.detections.length > 1}">{{fire.incident.detections.length}}</div>
                </a>
                </li>
                <li class="nav-item" role="presentation">
                <a href="#profile-video" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
                <div class="nav-field">Bearing</div>
                <div class="nav-value">{{fire.incident.cameraBearing}}°</div>
                </a>
                </li>
                <li class="nav-item" role="presentation">
                <a href="#profile-followers" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
                <div class="nav-field">First Detected</div>
                <div class="nav-value">{{fire.incident.fireIncidentDate | relativeDate}}</div>
                </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a href="#profile-followers" class="nav-link" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
                  <div class="nav-field">Last modified by</div>
                  <div class="nav-value">{{fire.incident.lastModifiedBy}}</div>
                  </a>
                  </li>
              </ul>-->

              <div class="mailbox d-none d-md-block">
                <!-- Desktop Display -->
                <div class="mailbox-toolbar">
                  <div class="mailbox-toolbar-item" *ngFor="let status of list" >
                    <button class="mailbox-toolbar-link btn" 
                      [title]="status.description"
                      (click)="updateStatus(status)" 
                      *ngIf="status.statusId == this.fire.incident.status.statusId || canClickStatus(status)"
                      [disabled]="!canClickStatus(status)"
                      [ngClass]="{'btn-theme':fire.incident.status.statusId == status.statusId,'btn-outline-default':canClickStatus(status),'btn-outline-dark':!canClickStatus(status)}">
                      {{status.displayName}}
                    </button>
                  </div>
                </div>                  
              </div>

              <div class="btn-group-vertical d-xs-block d-md-none wide pt-4">
                <!-- Phone Display -->
                <button type="button" class="btn bg-opacity-25 wide" *ngFor="let status of list" 
                  (click)="updateStatus(status)" 
                  [disabled]="!canClickStatus(status)"
                  [ngClass]="{
                    'btn-theme bg-white':fire.incident.status.statusId == status.statusId,
                    'btn-outline-light':canClickStatus(status),
                    'btn-outline-secondary':!canClickStatus(status)
                    }"                  
                  >{{status.displayName}}</button>
              </div>
            </div>  

            <div class="profile-sidebar">
              <table class="table table-sm">
                <tr *ngIf="fire.incident.initialLocationLat && fire.incident.initialLocationLon">
                    <th>Location</th>
                    <td>
                      {{fire.incident.initialLocationLat | number : '1.2-3'}}°,{{fire.incident.initialLocationLon | number : '1.2-3'}}°
                    </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>UTM</th>
                  <td>
                    {{fire.incident.initialEasting}}E,{{fire.incident.initialNorthing}}N 
                  </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>Zone</th>
                  <td>
                    Z{{fire.incident.initialUTMZone}} 
                  </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>Distance</th>
                  <td>
                    {{fire.incident.initialDistance}}km
                  </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>Bearing</th>
                  <td>
                    {{fire.incident.initialBearing}}°
                  </td>
                </tr>
                <tr>
                  <th>Reference#</th>
                  <td *ngIf="fire.incident.incidentReferenceUrl == null">
                    {{fire.incident.incidentReference}}
                  </td>
                  <td *ngIf="fire.incident.incidentReferenceUrl != null">
                    <a href="{{fire.incident.incidentReferenceUrl}}" target="_blank">
                      {{fire.incident.incidentReference}}
                    </a>                    
                  </td>
                </tr>
              </table>
            </div>

          </div>  
          
          <div class="row">
            <div class="col-12">

              

            </div>
          </div>

        </div>
        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row gx-4 mt-2">
    <div  [ngClass]="{'col-lg-12':!fullScreen,'col-lg-6':fullScreen}">

      <!-- Detection Images -->

      <div class="card mb-4" *ngIf="fire.incident" [ngClass]="{'card-expand':detectExpand}">
        <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
          <span class="flex-grow-1">First Detection</span>
          <!--<a (click)="zoom = !zoom" target="_blank" data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none mr"><i *ngIf="zoom" class="bi bi-zoom-out"></i><i *ngIf="!zoom" class="bi bi-zoom-in"></i></a>-->
          <a [href]="fire.incident.detections[0].imageUrl" target="_blank" title="Open image in new window" data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none mr"><i class="fa fa-external-link"></i></a>          
          <a data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none cursor" title="Expand image" (click)="detectExpand = !detectExpand"><i class="bi bi-fullscreen"></i></a>
        </div>
        <div class="card-body p-0">
          <smart-image-list #incidentImage *ngIf="!zoom" (pointerEvent)="displayDirection($event)" [showLineAt]="showLineAt" [showMetaData]="true" [images]="detectionImages" ></smart-image-list>
          <!--<smart-image #incidentImage *ngIf="!zoom" (pointerEvent)="displayDirection($event)" [showLineAt]="showLineAt" [overlayConfig]="fire.incident.detections[0].detectionMetaData" [showMetaData]="true" [src]="fire.incident.detections[0].imageUrl" ></smart-image>-->
          <smart-image *ngIf="zoom" [src]="fire.incident.firstZoomedImageUrl"></smart-image>
        </div>
      </div>

      <!-- Live Images -->

      <div class="card mb-4" *ngIf="fire.incident" [ngClass]="{'card-expand':liveExpand}">
        <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
          <span class="flex-grow-1">Live Image</span>
          
          <div class="spinner-border spinner-border-sm text-primary mr" role="status" *ngIf="timeLapseLoading"><span class="visually-hidden">Loading...</span></div>
          <a class="text-inverse text-opacity-50 text-decoration-none cursor mr" title="Load Time Lapse" *ngIf="latestImages?.length == 1 && !timeLapseLoading" (click)="loadTimelapse()">
            <i class="bi bi-clock-history"></i>
          </a>

          <a (click)="liveStream()" data-toggle="card-expand" style="cursor: pointer;" class="text-inverse text-opacity-50 text-decoration-none cursor mr" *ngIf="this.fire.camera?.canStream">
            <i [ngClass]="{'bi-camera-video':!liveStreaming,'bi-camera-video-fill':liveStreaming}" class="bi"></i>
          </a>

          <a data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none cursor" (click)="liveExpand = !liveExpand"><i class="bi bi-fullscreen"></i></a>

        </div>



        <div class="card-body p-0">
          <smart-image-list *ngIf="!streamUrl" [showLineAt]="showLineAt" [images]="latestImages" ></smart-image-list>
          <!--<smart-image [src]="latestImageUrl"></smart-image>-->
          <div *ngIf="streamUrl">
            <div class="overlay">
              <app-camera-controller #ptz [siteUri]="this.fire.camera?.siteUri" [simple]="true" 
                [ptzDirection]="ptzBearing" [ptzElevation]="ptzElevation" [ptzZoom]="ptzZoom" 
                (ptzDirectionChanged)="ptzBearing = $event" (ptzElevationChanged)="ptzElevation = $event" (ptzZoomChanged)="ptzZoom = $event"></app-camera-controller>
            </div>
            
            <img #livestream [src]="streamUrl" width="1280" height="960" alt="Axis Camera Stream">
            <div class="progress">
              <div class="progress-bar" style="width: {{timeout}}%"></div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="col-lg-6" *ngIf="fullScreen">

      <!-- Data -->
      <div class="row">

        <!-- Notes -->

        <div class="col-lg-6" *ngIf="fire && fire.incident && fullScreen">
          <div class="card mb-4 notes">
            <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
              <div class="flex-1">
                <div>Notes</div>
              </div>
            </div>
            <div class="card-body bg-inverse bg-opacity-10 sc scroll" style="height:100%" data-scrollbar="true" data-height="100%" data-init="true">
              <div class="widget-chat">
                <div class="widget-chat-item" *ngFor="let note of fire.incident.notes" [ngClass]="{'reply':note.lastModifiedBy != security.account.name}">
                  <div class="widget-chat-media"><img src="assets/img/user/user-2.jpg" alt="" /></div>
                  <div class="widget-chat-content">
                    <div class="widget-chat-name">{{note.lastModifiedBy}}</div>
                    <div class="widget-chat-message">
                      {{note.notes}}
                    </div>
                    <div class="widget-chat-status">{{note.lastModifiedDate | relativeDate}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Add new notes..." [(ngModel)]="newNote">
                <button class="btn btn-outline-default" type="button" (click)="addNewNote()"><i class="fa fa-paper-plane text-muted"></i></button>
              </div>
            </div>
            <div class="card-arrow">
              <div class="card-arrow-top-left"></div>
              <div class="card-arrow-top-right"></div>
              <div class="card-arrow-bottom-left"></div>
              <div class="card-arrow-bottom-right"></div>
            </div>
          </div>
        </div>

        <!-- Metadata -->
         
        <div class="col-lg-6" *ngIf="fire && fire.incident"  [ngClass]="{'col-lg-12':!fullScreen,'col-lg-6':fullScreen}">
          <div class="card mb-4 metadata">
            <div class="card-header d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
              <div class="flex-1">
                <div>Meta Data</div>
              </div>
            </div>
            <div class="card-body bg-inverse bg-opacity-10">
              <!-- Start Time, End Time, Incident Reference Number, Incident Reference URL -->
              <table class="table table-sm">
                <tr *ngIf="fire.incident.initialLocationLat && fire.incident.initialLocationLon">
                    <th>Location</th>
                    <td>
                      {{fire.incident.initialLocationLat | number : '1.2-3'}}°,{{fire.incident.initialLocationLon | number : '1.2-3'}}°
                    </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>UTM</th>
                  <td>
                    {{fire.incident.initialEasting}}E,{{fire.incident.initialNorthing}}N 
                  </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>Zone</th>
                  <td>
                    Z{{fire.incident.initialUTMZone}} 
                  </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>Distance</th>
                  <td>
                    {{fire.incident.initialDistance}}km
                  </td>
                </tr>
                <tr *ngIf="fire.incident.initialEasting && fire.incident.initialNorthing && fire.incident.initialUTMZone">
                  <th>Bearing</th>
                  <td>
                    {{fire.incident.initialBearing}}°
                  </td>
                </tr>
                <tr>
                  <th>Reference#</th>
                  <td *ngIf="fire.incident.incidentReferenceUrl == null">
                    {{fire.incident.incidentReference}}
                  </td>
                  <td *ngIf="fire.incident.incidentReferenceUrl != null">
                    <a href="{{fire.incident.incidentReferenceUrl}}" target="_blank">
                      {{fire.incident.incidentReference}}
                    </a>                    
                  </td>
                </tr>
              </table>
            </div> 
          </div>
        </div>

      </div>

    </div>
  </div>
  <div class="row gx-4 mt-2">
    <div class="col-lg-6">
      
    </div>
    
</div>

